import React from 'react'
import { Tab } from 'semantic-ui-react'
import CurrentMilkPriceWidget from './widgets/CurrentMilkPriceWidget'
import SegmentationTableWidget from './widgets/SegmentationTableWidget'
import { useTranslation } from 'react-i18next'

const MilkPriceDashboard: React.FC = () => {
  const { t } = useTranslation()

  const panes = [
    {
      menuItem: t('Current Milk Price'),
      render: () => <CurrentMilkPriceWidget />
    },
    {
      menuItem: t('Segmentation table'),
      render: () => <SegmentationTableWidget />
    }
  ]

  return (
    <div style={{ marginTop: '1em' }}>
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={panes}
      />
    </div>
  )
}

export default MilkPriceDashboard